module.exports = __webpack_public_path__ + "static/img/tai-sui-dian.fee0cf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/tai-sui-dian.jpg
// module id = Tb0Q
// module chunks = 1